import { useEffect, useState } from 'react'
import { apiGet } from '@/lib/api'
import { getWeekKey } from '@/lib/dates'
import { computePlanReliability } from '@/lib/calculations'
import type { PlanItem, Task } from '@/types'

// % of last week's planned tasks actually completed (not carried over).
// null while loading or when there was no plan for last week at all.
export function usePlanReliability(tasks: Task[]) {
  const [rate, setRate] = useState<number | null>(null)

  useEffect(() => {
    let cancelled = false
    apiGet<PlanItem[]>(`/api/planning/${getWeekKey(-1)}`).then(items => {
      if (cancelled) return
      setRate(items ? computePlanReliability(items, tasks) : null)
    })
    return () => { cancelled = true }
  }, [tasks])

  return rate
}
